import api from "./api";

const conversionService = {
  createConversion: (body) => api.post("/timetable/conversion", body),

  getConversions: (params) => api.get("/timetable/conversion", { params }),

  getConversionById: (id) => api.get(`/timetable/conversion/${id}`),

  deleteConversion: (id) => api.delete(`/timetable/conversion/${id}`),
};

export default conversionService;
